import script from "./ClearCacheDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearCacheDevices.vue?vue&type=script&setup=true&lang=js"

import "./ClearCacheDevices.vue?vue&type=style&index=0&id=590b21cb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590b21cb"]])

export default __exports__